import Logo from '../assets/svgs/Logo.js';
import Mobile from '../assets/svgs/Mobile.js';
import MyWallet from '../assets/svgs/MyWallet.js';
import Profile from '../assets/svgs/Profile.js';
import PrivacyPolicy from '../assets/svgs/PrivacyPolicy.js';
import HowToPlay from '../assets/svgs/HowToPlay.js';
import ContactUs from '../assets/svgs/ContactUs.js';
import ReferList from '../assets/svgs/ReferList.js';
import LeaderBoard from '../assets/svgs/Leaderboard.js';
import AboutUs from '../assets/svgs/AboutUs.js';
import ReferFriends from '../assets/svgs/ReferFriends.js';
import Logout from '../assets/svgs/Logout.js';
import MyContest from '../assets/svgs/MyContest.js';
import More from '../assets/svgs/More.js';
import Account from '../assets/svgs/Account.js';
import DownArrow from '../assets/svgs/DownArrow.js';
import RightArrow from '../assets/svgs/RightArrow.js';
import Bonus from '../assets/svgs/Bonus.js';
import Confirm from '../assets/svgs/Confirm.js';
import Wallet from '../assets/svgs/Wallet.js';
import Back from '../assets/svgs/Back.js';
import Clone from '../assets/svgs/CloneTeam.js';
import Edit from '../assets/svgs/EditTeam.js';
import Preview from '../assets/svgs/PreviewTeam.js';
import Close from '../assets/svgs/Close.js';
import Email from '../assets/svgs/Email.js';
import Password from '../assets/svgs/Password.js';
import SelectDate from '../assets/svgs/SelectDate.js';
import ReferImage from '../assets/svgs/ReferImage.js';
import ContactPageImage from '../assets/svgs/ContactPageImage.js';
import ContactEmail from '../assets/svgs/ContactEmail.js';
import ContactMobile from '../assets/svgs/ContactMobile.js';
import PANcard from '../assets/svgs/PancardUpload.js';
import Picture from '../assets/svgs/Picture.js';
import Minus from '../assets/svgs/Minus.js';
import Plus from '../assets/svgs/Plus.js';
import Add from '../assets/svgs/Add.js';
import Igamio from '../assets/svgs/Igamio.js';
import Notification_bell from '../assets/svgs/NotificationBell.js';
import Wallet_Account from '../assets/svgs/WalletAccount.js';
import SwitchTeam from '../assets/svgs/SwitchTeam.js';
import NoTeamData from '../assets/svgs/CreateTeam.js';
import CricketTab from '../assets/svgs/CricketTab.js';
import FootballTab from '../assets/svgs/FootballTab.js';
import KabaddiTab from '../assets/svgs/KabaddiTab.js';
import NBATab from '../assets/svgs/NbaTab.js';
import ContestTab from '../assets/svgs/ContestTab.js';
import JoinedTab from '../assets/svgs/JoinedTab.js';
import MyTeamsTab from '../assets/svgs/MyTeamsTab.js';
import ViewLeaderBoard from '../assets/svgs/ViewLeaderboard.js';
import EditMobile from '../assets/svgs/EditMobile.js';
import ReferralBonus from '../assets/svgs/ReferralBonus.js';
import Transfer from '../assets/svgs/Transfer.js';
import PaytmTransfer from '../assets/svgs/PaytmTransfer.js';
import MyBalance from '../assets/svgs/MyBalance.js';
import ReferAndEarn from '../assets/svgs/ReferAndEarn.js';
import MyProfile from '../assets/svgs/MyProfile.js';
import TermsAndCondition from '../assets/svgs/TermsAndConditions.js';
import JoinTelegram from '../assets/svgs/JoinTelegram.js';
import ContactFaq from '../assets/svgs/ContactFaq.js';
import Verified from '../assets/svgs/Verified.js';
import PANCardUpload from '../assets/svgs/PancardUpload.js';
import TotalContestWon from '../assets/svgs/TotalContestWin.js';
import TotalContest from '../assets/svgs/TotalContest.js';
import TotalMatchPlayed from '../assets/svgs/TotalMatchPlayed.js';
import TotalWinning from '../assets/svgs/TotalWinning.js';
import Announcement from '../assets/svgs/Announcement.js';
import GetStarted from '../assets/svgs/GetStarted.js';
import Promotions from '../assets/svgs/Promotions.js';
import FAQHowToPlay from '../assets/svgs/FaqHowToPlay.js';
import FilterDown from '../assets/svgs/FilterDown.js';
import FilterUp from '../assets/svgs/FilterUp.js';
import GoCP from '../assets/svgs/GoCp.js';
import GoToGame from '../assets/svgs/GoToGame.js';
import GoToPoker from '../assets/svgs/GoToPoker.js';
import GoToHome from '../assets/svgs/GoToHome.js';
import FAQ from '../assets/svgs/Faq.js';
import Legalities from '../assets/svgs/Legalities.js';
import KabaddiAllRounder from '../assets/svgs/KabaddiAllRounder.js';
import KabaddiDefenders from '../assets/svgs/KabaddiDefenders.js';
import KabaddiRaiders from '../assets/svgs/KabaddiRaiders.js';
import Trash from '../assets/svgs/Trash.js';
import Menu from '../assets/svgs/Menu.js';
import Cancel from '../assets/svgs/Cancel.js';
import Teams from '../assets/svgs/Teams.js';
import JoiningBonus from '../assets/svgs/JoiningBonus.js';
import PlatformFee from '../assets/svgs/PlatformFee.js';
import DashboardCricket from '../assets/svgs/DashboardCricket.js';
import DashboardPoker from '../assets/svgs/DashboardPoker.js';
import DashboardFootball from '../assets/svgs/DashboardFootball.js';
import Timer from '../assets/svgs/Timer';
import WinningPercentage from '../assets/svgs/WinningPercentage';
import GuaranteedLeague from '../assets/svgs/GuaranteedLeague';
import H2HLeague from '../assets/svgs/H2HLeague';
import IstWinner from '../assets/svgs/IstWinner';
import MultiEntryLeague from '../assets/svgs/MultiEntryLeague';
import SingleEntryLeague from '../assets/svgs/SingleEntryLeague';
import Share from '../assets/svgs/Share';
import TeamPlus from '../assets/svgs/TeamPlus';
import TeamMinus from '../assets/svgs/TeamMinus';
import CricketBatsman from '../assets/svgs/CricketBatsman';
import CricketWicketKeeper from '../assets/svgs/CricketWicketKeeper';
import CricketAllRounder from '../assets/svgs/CricketAllRounder';
import CricketBowler from '../assets/svgs/CricketBowler';
import VerificationCheck from '../assets/svgs/VerificationCheck';
import VerificationUnCheck from '../assets/svgs/VerificationUnCheck';
import PlayingHistoryContestWon from '../assets/svgs/PlayingHistoryContestWon';
import PlayingHistoryContestsPlayed from '../assets/svgs/PlayingHistoryContestsPlayed';
import PlayingHistoryMatchPlayed from '../assets/svgs/PlayingHistoryMatchPlayed';
import PlayingHistoryWinnings from '../assets/svgs/PlayingHistoryWinnings';
import Pancard from '../assets/svgs/Pan';
import Bank from '../assets/svgs/Bank';
import Info from '../assets/svgs/Info';
import WalletIGamio from '../assets/svgs/WalletIGamio';
import WalletBonus from '../assets/svgs/WalletBonus';
import WalletPoker from '../assets/svgs/WalletPoker';
import WalletWinnings from '../assets/svgs/WalletWinnings';
import Pocket from '../assets/svgs/Pocket';
import Warning from '../assets/svgs/Warning';
import ModalBack from '../assets/svgs/ModalBack';
import Empty from '../assets/svgs/Empty';
import Failed from '../assets/svgs/Failed';
import FilterList from '../assets/svgs/FilterList';
import IGamioLogo from '../assets/svgs/IGamioLogo';
import Avatar from '../assets/svgs/Avatar';
import MoneyIcon from '../assets/svgs/MoneyIcon';
import ProfileAvatar from '../assets/svgs/ProfileAvatar';
import SubstituteButton from '../assets/svgs/SubstituteButton';
import SubstituteRefresh from '../assets/svgs/SubstituteRefresh';
import PlayerTypeMinus from '../assets/svgs/PlayerTypeMinus';
import YesNo_YesBtn from '../assets/svgs/YesNo_YesBtn';
import YesNo_NoBtn from '../assets/svgs/YesNo_NoBtn';
import YesNo_2xBtn from '../assets/svgs/YesNo_2xBtn';
import YesNo_EditBtn from '../assets/svgs/YesNo_EditBtn';
import YesNo_SaveBtn from '../assets/svgs/YesNo_SaveBtn';
import YesNo_2xBtnSelect from '../assets/svgs/YesNo_2xBtnSelect';
import FootballDEF from '../assets/svgs/Football_DEF';
import Football_GK from '../assets/svgs/Football_GK';
import Football_MID from '../assets/svgs/Football_MID';
import Football_ST from '../assets/svgs/Football_ST';
import Home from '../assets/svgs/HomeIcon.js';
import Favourites from '../assets/svgs/FavouritesIcon.js';
import History from '../assets/svgs/HistoryIcon.js';
import NewGames from '../assets/svgs/NewGamesIcon.js';
import Cards from '../assets/svgs/CardsIcon.js';
import Puzzles from '../assets/svgs/PuzzlesIcon.js';
import Arcade from '../assets/svgs/Arcade.js';
import Quiz from '../assets/svgs/QuizIcon.js';
import Racing from '../assets/svgs/RacingIcon.js';
import Cash from '../assets/svgs/Cash.js';
import Sports from '../assets/svgs/Sports.js';
import EditAvatar from '../assets/svgs/Edit.js';
import FirstPrize from '../assets/svgs/FirstPrize';
import GamioGLogo from '../assets/svgs/GamioGLogo';
import Giftbox from '../assets/svgs/Giftbox';
import Poker from '../assets/svgs/Poker';
import RupeeNote from '../assets/svgs/RupeeNote';
import PlayerVsPlayerMobile from '../assets/svgs/PlayerVsPlayer';
import HourGlass from '../assets/svgs/HourGlass';
import Xp from '../assets/svgs/Xp';
import NewMobile from '../assets/svgs/NewMobile';
import CardsMobile from '../assets/svgs/CardsMobile';
import QuizMobile from '../assets/svgs/QuizMobile';
import RacingMobile from '../assets/svgs/RacingMobile';
import SportsMobile from '../assets/svgs/SportsMobile';
import PuzzlesMobile from '../assets/svgs/PuzzlesMobile';
import ArcadeMobile from '../assets/svgs/ArcadeMobile';
import TimerMobile from '../assets/svgs/TimerMobile';
import ArrowExpand from '../assets/svgs/ArrowExpand';
import ArrowCollapse from '../assets/svgs/ArrowCollapse';
import Phone from '../assets/svgs/Phone';
import Website from '../assets/svgs/Website';
import Coins from '../assets/svgs/Coins.js';
import StrategyMobile from '../assets/svgs/StrategyMobile';
export default {
  PlayerTypeMinus,
  SubstituteRefresh,
  SubstituteButton,
  ProfileAvatar,
  MoneyIcon,
  Avatar,
  IGamioLogo,
  FilterList,
  Failed,
  Empty,
  ModalBack,
  Warning,
  Pocket,
  WalletIGamio,
  WalletBonus,
  WalletPoker,
  WalletWinnings,
  Info,
  Bank,
  Pancard,
  PlayingHistoryContestWon,
  PlayingHistoryContestsPlayed,
  PlayingHistoryMatchPlayed,
  PlayingHistoryWinnings,
  VerificationUnCheck,
  VerificationCheck,
  CricketBatsman,
  CricketWicketKeeper,
  CricketAllRounder,
  CricketBowler,
  TeamPlus,
  TeamMinus,
  Share,
  GuaranteedLeague,
  H2HLeague,
  IstWinner,
  MultiEntryLeague,
  SingleEntryLeague,
  WinningPercentage,
  Timer,
  DashboardCricket,
  DashboardFootball,
  DashboardPoker,
  KabaddiAllRounder,
  KabaddiDefenders,
  KabaddiRaiders,
  FAQ,
  Legalities,
  GoCP,
  GoToGame,
  GoToPoker,
  GoToHome,
  Logo,
  Mobile,
  MyWallet,
  Profile,
  PrivacyPolicy,
  HowToPlay,
  ContactUs,
  ReferList,
  LeaderBoard,
  AboutUs,
  ReferFriends,
  Logout,
  // Home,
  MyContest,
  More,
  Account,
  DownArrow,
  RightArrow,
  Bonus,
  Confirm,
  Wallet,
  Back,
  Clone,
  Edit,
  Preview,
  Close,
  Email,
  Password,
  SelectDate,
  ReferImage,
  ContactPageImage,
  ContactEmail,
  ContactMobile,
  PANcard,
  Picture,
  Minus,
  Plus,
  Add,
  Igamio,
  Notification_bell,
  Wallet_Account,
  SwitchTeam,
  NoTeamData,
  CricketTab,
  FootballTab,
  KabaddiTab,
  NBATab,
  JoinedTab,
  MyTeamsTab,
  ViewLeaderBoard,
  EditMobile,
  ReferralBonus,
  Transfer,
  PaytmTransfer,
  MyBalance,
  ReferAndEarn,
  MyProfile,
  TermsAndCondition,
  JoinTelegram,
  ContactFaq,
  Verified,
  PANCardUpload,
  TotalContest,
  TotalContestWon,
  TotalMatchPlayed,
  TotalWinning,
  Announcement,
  GetStarted,
  Promotions,
  FAQHowToPlay,
  FilterDown,
  FilterUp,
  Trash,
  Menu,
  Cancel,
  ContestTab,
  Teams,
  JoiningBonus,
  PlatformFee,
  YesNo_YesBtn,
  YesNo_NoBtn,
  YesNo_2xBtn,
  YesNo_EditBtn,
  YesNo_SaveBtn,
  YesNo_2xBtnSelect,
  FootballDEF,
  Football_GK,
  Football_MID,
  Football_ST,
  Home,
  Favourites,
  History,
  NewGames,
  Cards,
  Puzzles,
  Arcade,
  Quiz,
  Racing,
  Cash,
  Sports,
  EditAvatar,
  FirstPrize,
  GamioGLogo,
  Giftbox,
  Poker,
  RupeeNote,
  PlayerVsPlayerMobile,
  HourGlass,
  Xp,
  NewMobile,
  CardsMobile,
  QuizMobile,
  RacingMobile,
  SportsMobile,
  PuzzlesMobile,
  ArcadeMobile,
  TimerMobile,
  ArrowCollapse,
  ArrowExpand,
  Phone,
  Website,
  Coins,
  StrategyMobile
};
